import momArt from "../assets/balamani-konatham.jpg";
import { t } from "../i18n";

export default function LoginHero({ lang }) {
  return (
    <section className="tt-login-hero" aria-label={t(lang, "dedicationName")}>
      <div className="tt-mural">
        <svg className="tt-mural-lines" viewBox="0 0 800 640" aria-hidden="true">
          <path
            d="M170 430 C 240 360, 300 300, 400 280"
            fill="none"
            stroke="rgba(212,175,55,0.45)"
            strokeWidth="1.6"
            strokeDasharray="5 7"
          />
          <path
            d="M630 430 C 560 360, 500 300, 400 280"
            fill="none"
            stroke="rgba(212,175,55,0.45)"
            strokeWidth="1.6"
            strokeDasharray="5 7"
          />
          <path
            d="M400 470 C 400 520, 400 540, 400 580"
            fill="none"
            stroke="rgba(26,95,74,0.35)"
            strokeWidth="1.6"
            strokeDasharray="4 6"
          />
        </svg>

        <figure className="tt-orbit tt-orbit-family">
          <svg viewBox="0 0 88 88" aria-hidden="true">
            <circle cx="44" cy="44" r="42" fill="#fff8ee" stroke="#d4af37" />
            <circle cx="32" cy="30" r="9" fill="#1a5f4a" />
            <path d="M18 62 c0-12 8-18 14-18 s14 6 14 18" fill="#1a5f4a" />
            <circle cx="58" cy="32" r="7" fill="#c45c26" />
            <path d="M46 64 c0-10 7-15 12-15 s12 5 12 15" fill="#c45c26" />
          </svg>
          <figcaption>{t(lang, "sceneFamily")}</figcaption>
        </figure>

        <figure className="tt-orbit tt-orbit-doctor">
          <svg viewBox="0 0 88 88" aria-hidden="true">
            <circle cx="44" cy="44" r="42" fill="#fff8ee" stroke="#d4af37" />
            <circle cx="44" cy="28" r="9" fill="#16332b" />
            <path d="M24 66 c2-16 10-22 20-22 s18 6 20 22" fill="#16332b" />
            <path d="M38 48 h12 v16 h-12 z" fill="#e8f3ee" />
            <circle cx="62" cy="50" r="7" fill="none" stroke="#c45c26" strokeWidth="2.4" />
            <path d="M62 57 v8" stroke="#c45c26" strokeWidth="2.4" />
          </svg>
          <figcaption>{t(lang, "sceneDoctor")}</figcaption>
        </figure>

        <figure className="tt-orbit tt-orbit-meds">
          <svg viewBox="0 0 88 88" aria-hidden="true">
            <circle cx="44" cy="44" r="42" fill="#fff8ee" stroke="#d4af37" />
            <rect x="18" y="36" width="28" height="16" rx="8" fill="#1a5f4a" />
            <rect x="42" y="36" width="28" height="16" rx="8" fill="#e8f3ee" stroke="#1a5f4a" />
            <rect x="24" y="58" width="18" height="12" rx="2" fill="#d4af37" opacity="0.85" />
            <rect x="46" y="58" width="18" height="12" rx="2" fill="#c45c26" opacity="0.75" />
          </svg>
          <figcaption>{t(lang, "sceneMedicine")}</figcaption>
        </figure>

        <div className="tt-portrait">
          <img src={momArt} alt={t(lang, "dedicationName")} />
        </div>
      </div>

      <div className="tt-login-hero-copy">
        <p className="tt-script">{t(lang, "inMemory")}</p>
        <h1>{t(lang, "dedicationName")}</h1>
        <p className="tt-dates">{t(lang, "dedicationDates")}</p>
        <p className="tt-why">{t(lang, "dedicationBody")}</p>
      </div>
    </section>
  );
}
